module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticStyle: {
      "height": "100%",
      "padding": "0"
    },
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "fill-height": "",
      "row": ""
    }
  }, [_c('AdminSideBarMenu'), _vm._v(" "), _c('v-flex', {
    staticClass: "dashboard-view",
    attrs: {
      "x12": ""
    }
  }, [_c('v-container', {
    staticStyle: {
      "overflow": "hidden"
    },
    attrs: {
      "fluid": "",
      "grid-list-md": "",
      "mb-2": ""
    }
  }, [_c('v-layout', {
    staticClass: "number-metrics dashboard-cards",
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "lg3": ""
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "dashboard-card_title pb-1"
  }, [_c('div', {
    staticClass: "stat_title"
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v("Website Traffic")])])]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "pl-4": "",
      "pr-4": "",
      "pt-2": "",
      "pb-4": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-card', {
    staticClass: "number-metrics-item",
    attrs: {
      "flat": ""
    }
  }, [_c('span', {
    staticClass: "metric-key"
  }, [_vm._v("Month to Date")]), _vm._v(" "), _c('div', {
    staticClass: "pt-1"
  }, [_c('div', {
    staticClass: "title bold pr-1"
  }, [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.wt1)))]), _vm._v(" "), _c('span', {
    staticClass: "body-2",
    class: _vm.p1c,
    attrs: {
      "id": "traffic_percent"
    }
  }, [_c('v-icon', {
    attrs: {
      "medium": ""
    }
  }, [_vm._v("mdi-menu-up")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "medium": ""
    }
  }, [_vm._v("mdi-menu-down")]), _vm._v("\n                        " + _vm._s(_vm.p1) + "%\n                      ")], 1)])])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-card', {
    staticClass: "pl-3",
    attrs: {
      "flat": ""
    }
  }, [_c('span', {
    staticClass: "metric-key"
  }, [_vm._v("Year to Date")]), _vm._v(" "), _c('div', {
    staticClass: "pt-1"
  }, [_c('div', {
    staticClass: "title bold pr-1"
  }, [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.wt2)))]), _vm._v(" "), _c('span', {
    staticClass: "body-2",
    class: _vm.p2c
  }, [_c('v-icon', {
    attrs: {
      "medium": ""
    }
  }, [_vm._v("mdi-menu-up")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "medium": ""
    }
  }, [_vm._v("mdi-menu-down")]), _vm._v("\n                        " + _vm._s(_vm.p2) + "%\n                      ")], 1)])])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "lg3": ""
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "dashboard-card_title pb-1"
  }, [_c('div', {
    staticClass: "stat_title "
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v("New Users")])])]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "pl-4": "",
      "pr-4": "",
      "pt-2": "",
      "pb-4": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-card', {
    staticClass: "number-metrics-item",
    attrs: {
      "flat": ""
    }
  }, [_c('span', {
    staticClass: "metric-key"
  }, [_vm._v("Month to Date")]), _vm._v(" "), _c('div', {
    staticClass: "pt-1"
  }, [_c('div', {
    staticClass: "title bold pr-1"
  }, [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.nt1)))]), _vm._v(" "), _c('span', {
    staticClass: "body-2",
    class: _vm.np1c,
    attrs: {
      "id": "traffic_percent"
    }
  }, [_c('v-icon', {
    attrs: {
      "medium": ""
    }
  }, [_vm._v("mdi-menu-up")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "medium": ""
    }
  }, [_vm._v("mdi-menu-down")]), _vm._v("\n                        " + _vm._s(_vm.np1) + "%\n                      ")], 1)])])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-card', {
    staticClass: "pl-3",
    attrs: {
      "flat": ""
    }
  }, [_c('span', {
    staticClass: "metric-key"
  }, [_vm._v("Year to Date")]), _vm._v(" "), _c('div', {
    staticClass: "pt-1"
  }, [_c('div', {
    staticClass: "title bold pr-1"
  }, [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.nt2)))]), _vm._v(" "), _c('span', {
    staticClass: "body-2",
    class: _vm.np2c
  }, [_c('v-icon', {
    attrs: {
      "medium": ""
    }
  }, [_vm._v("mdi-menu-up")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "medium": ""
    }
  }, [_vm._v("mdi-menu-down")]), _vm._v("\n                        " + _vm._s(_vm.np2) + "%\n                      ")], 1)])])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "lg3": ""
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "dashboard-card_title pb-1"
  }, [_c('div', {
    staticClass: "stat_title"
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v("Avg. Time-on-site")])])]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "pl-4": "",
      "pr-4": "",
      "pt-2": "",
      "pb-4": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-card', {
    staticClass: "number-metrics-item",
    attrs: {
      "flat": ""
    }
  }, [_c('span', {
    staticClass: "metric-key"
  }, [_vm._v("Month to Date")]), _vm._v(" "), _c('div', {
    staticClass: "pt-1"
  }, [_c('div', {
    staticClass: "title bold pr-1"
  }, [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.tt1)))]), _vm._v(" "), _c('span', {
    staticClass: "body-2",
    class: _vm.tp1c,
    attrs: {
      "id": "traffic_percent"
    }
  }, [_c('v-icon', {
    attrs: {
      "medium": ""
    }
  }, [_vm._v("mdi-menu-up")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "medium": ""
    }
  }, [_vm._v("mdi-menu-down")]), _vm._v("\n                        " + _vm._s(_vm.tp1) + "%\n                      ")], 1)])])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-card', {
    staticClass: "pl-3",
    attrs: {
      "flat": ""
    }
  }, [_c('span', {
    staticClass: "metric-key"
  }, [_vm._v("Year to Date")]), _vm._v(" "), _c('div', {
    staticClass: "pt-1"
  }, [_c('div', {
    staticClass: "title bold pr-1"
  }, [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.tt2)))]), _vm._v(" "), _c('span', {
    staticClass: "body-2",
    class: _vm.tp2c
  }, [_c('v-icon', {
    attrs: {
      "medium": ""
    }
  }, [_vm._v("mdi-menu-up")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "medium": ""
    }
  }, [_vm._v("mdi-menu-down")]), _vm._v("\n                        " + _vm._s(_vm.tp2) + "%\n                      ")], 1)])])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "lg3": ""
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "dashboard-card_title pb-1"
  }, [_c('div', {
    staticClass: "stat_title"
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v("Engagement (MDT)")])])]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "pl-4": "",
      "pr-4": "",
      "pt-2": "",
      "pb-4": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-card', {
    staticClass: "number-metrics-item",
    attrs: {
      "flat": ""
    }
  }, [_c('span', {
    staticClass: "metric-key"
  }, [_vm._v("Post")]), _vm._v(" "), _c('div', {
    staticClass: "pt-1"
  }, [_c('div', {
    staticClass: "title bold"
  }, [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.pt1)))]), _vm._v(" "), _c('span', {
    staticClass: "body-2",
    class: _vm.pp1c,
    attrs: {
      "id": "traffic_percent"
    }
  }, [_c('v-icon', {
    attrs: {
      "medium": ""
    }
  }, [_vm._v("mdi-menu-up")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "medium": ""
    }
  }, [_vm._v("mdi-menu-down")]), _vm._v("\n                        " + _vm._s(_vm.pp1) + "%\n                      ")], 1)])])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-card', {
    staticClass: "pl-3",
    attrs: {
      "flat": ""
    }
  }, [_c('span', {
    staticClass: "metric-key"
  }, [_vm._v("Likes")]), _vm._v(" "), _c('div', {
    staticClass: "pt-1"
  }, [_c('div', {
    staticClass: "title bold pr-1"
  }, [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.pt2)))]), _vm._v(" "), _c('span', {
    staticClass: "body-2",
    class: _vm.pp2c
  }, [_c('v-icon', {
    attrs: {
      "medium": ""
    }
  }, [_vm._v("mdi-menu-up")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "medium": ""
    }
  }, [_vm._v("mdi-menu-down")]), _vm._v("\n                        " + _vm._s(_vm.pp2) + "%\n                      ")], 1)])])], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-container', {
    staticClass: "pa-1 mb-2",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('chart-view')], 1)], 1)], 1), _vm._v(" "), _c('block1'), _vm._v(" "), _c('PageFooter')], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3733d540","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/admin/settings/IndexView.vue
// module id = 1661
// module chunks = 0